<template>
  <div
    class="country-card card-condition connection-type"
    :class="{
      noteq: value === 'IS_NOT_WEB_VIEW',
      'card-condition__planLimits': hasPlanLimitsRestriction('webViewCondition'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('webViewCondition')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close"></ui-icon>
    <ui-radio-group style-type="inline" v-model="value" :label="t('WebView Traffic')">
      <ui-radio class="ml-16" value="IS_WEB_VIEW" :label="t('Is WebView')" />
      <ui-radio class="ml-16" value="IS_NOT_WEB_VIEW" :label="t('Not WebView')" />
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'webViewMark',
  defaultValue: 'IS_NOT_WEB_VIEW',
  planLimitsKey: 'webViewCondition',
});
</script>

<style lang="scss"></style>
